import ImportsHtml from '../../app-lite/imports/imports.html';

export function ImportsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    name       : 'app.imports',
    templateUrl: ImportsHtml,
    url        : '/imports'
  });
};